import { IntegrityEvent } from './IntegrityEvent';
import { AbstractService } from '../Service/AbstractService';
import { isErrorResponse } from '@standardnotes/responses';
import { SyncEvent } from '../Event/SyncEvent';
export class IntegrityService extends AbstractService {
    constructor(integrityApi, itemApi, payloadManager, logger, internalEventBus) {
        super(internalEventBus);
        this.integrityApi = integrityApi;
        this.itemApi = itemApi;
        this.payloadManager = payloadManager;
        this.logger = logger;
        this.internalEventBus = internalEventBus;
    }
    async handleEvent(event) {
        var _a, _b;
        if (event.type !== SyncEvent.SyncRequestsIntegrityCheck) {
            return;
        }
        const integrityCheckResponse = await this.integrityApi.checkIntegrity(this.payloadManager.integrityPayloads);
        if (isErrorResponse(integrityCheckResponse)) {
            this.logger.error(`Could not obtain integrity check: ${(_a = integrityCheckResponse.data.error) === null || _a === void 0 ? void 0 : _a.message}`);
            return;
        }
        const serverItemResponsePromises = [];
        for (const mismatch of integrityCheckResponse.data.mismatches) {
            serverItemResponsePromises.push(this.itemApi.getSingleItem(mismatch.uuid));
        }
        const serverItemResponses = await Promise.all(serverItemResponsePromises);
        const rawPayloads = [];
        for (const serverItemResponse of serverItemResponses) {
            if (serverItemResponse.data == undefined ||
                isErrorResponse(serverItemResponse) ||
                !('item' in serverItemResponse.data)) {
                this.logger.error(`Could not obtain item for integrity adjustments: ${isErrorResponse(serverItemResponse) ? (_b = serverItemResponse.data.error) === null || _b === void 0 ? void 0 : _b.message : ''}`);
                continue;
            }
            rawPayloads.push(serverItemResponse.data.item);
        }
        await this.notifyEventSync(IntegrityEvent.IntegrityCheckCompleted, {
            rawPayloads: rawPayloads,
            source: event.payload.source,
        });
    }
}
